import { useState } from 'react';
import ModalWrapper from './modal-wrapper';


export const useModal = (Component: JSX.Element) => {
    const [ modalOpen, setModalOpen ] = useState(false);

    const openModal = () => {
        setModalOpen(true);

        document.body.addEventListener("keyup", handleModalKeyUp);
    }

    const closeModal = () => {
        setModalOpen(false);

        document.body.removeEventListener("keyup", handleModalKeyUp);
    }

    const ModalContent = () => (
        <ModalWrapper onClick={(event) => handleModalClick(event)}> 
            {Component}
        </ModalWrapper>
    );

    const handleModalClick = (event: React.MouseEvent<HTMLDivElement>) => {
        const target = event.target as HTMLInputElement;
        if (target?.id === "modal-overlay" || target?.id === "modal-close-button") {
            closeModal()
        }
    };

    const handleModalKeyUp = (event: KeyboardEvent) => {
        if (event.keyCode === 27 || event.key === 'Escape') {
            closeModal();
        }
    };

    return { modalOpen, ModalContent, openModal, closeModal };
}